export default __webpack_public_path__ + "static/img-1-cea462888c35394876f696f0f1de7efb.png";